import React, { useEffect } from 'react';
import { signoutRedirectCallback } from '../../services/userService';
import { useNavigate } from 'react-router-dom';

function SignoutOidc() {
  const history = useNavigate();
  useEffect(() => {
    async function signoutAsync() {
      await signoutRedirectCallback();
      history('/');
    }
    signoutAsync();
  }, [history]);

  return <div>You have been logged out</div>;
}

export default SignoutOidc;
